import { useSelector } from 'react-redux';
import { ErrorWrapper } from '@rsos/base-components/form/ErrorsWrapper';
import { Box, Text } from '@rsos/components/capstone/base';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';
import { selectExistingRequest } from '@rsos/reduxDataStore';
import { Label, TextArea } from '../AirAmbulanceFormStandalone.styles';
import { GROUND_CONTACT, PATIENT_INFO } from '../constants';
import { REQUIRED_ERROR } from '../validation';

const ContactSection = ({
  values,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
  setFieldTouched,
}) => {
  const existingRequest = useSelector(selectExistingRequest);

  return (
    <>
      <Box pb={3}>
        <Label>
          <Text size="small" color="primaryText">
            Ground Contact Radio Channel & Unit Name*
          </Text>
        </Label>
        <InputText
          shouldErrorTakeSpace
          id={GROUND_CONTACT}
          name={GROUND_CONTACT}
          type="text"
          setFieldValue={setFieldValue}
          value={values.ground_contact}
          onChange={e => {
            handleChange(e);
            setFieldTouched(GROUND_CONTACT, true);
          }}
          onBlur={handleBlur}
          error={
            touched.ground_contact && values.ground_contact.length === 0
              ? REQUIRED_ERROR
              : null
          }
          style={{ fontSize: '14px' }}
        />
      </Box>

      <Box pb={3}>
        <Label>
          <Text size="small" color="primaryText">
            Incident/Patient Info*
          </Text>
        </Label>
        <TextArea
          shouldErrorTakeSpace
          id={PATIENT_INFO}
          name={PATIENT_INFO}
          setFieldValue={setFieldValue}
          value={values.patient_info}
          onChange={e => {
            handleChange(e);
            setFieldTouched(PATIENT_INFO, true);
          }}
          disabled={existingRequest}
          onBlur={handleBlur}
          placeholder="Additional Information for Responders"
          rows={4}
          error={
            touched.patient_info && values.patient_info.length === 0
              ? REQUIRED_ERROR
              : null
          }
          style={{ fontSize: '14px' }}
        />
        {touched.patient_info && values.patient_info.length === 0 && (
          <ErrorWrapper error={REQUIRED_ERROR} id={'patient_info_error'} />
        )}
      </Box>
    </>
  );
};

export default ContactSection;
